<template>
  <v-card class="card d-flex align-stretch align-center">
    <v-img class="icon" alt="icon" :src="item.imgSrc"><span class="title">{{item.text}}</span></v-img>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {
    bg () {
      return this.item && this.item.bg ? {
        backgroundColor: this.item.bg
      } : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  color: #FFF;
  box-shadow: none!important;
  cursor: pointer;
  text-align: center;
  .title {
    color: #3171b7;
    font-size: 16px!important;
    margin-top: 3px;
    margin-left: -15px;
    @media (min-width:520px) and (max-width:959px){
      font-size: 32px!important;
    }
    @media (min-width:1263px) {
      font-size: 20px!important;
    }
    @media (max-width:519px) {
      font-size: 24px!important;
    }
  }
}
</style>
